<template>
    <footer class="footer" v-if="salesCard != null" id="footer">
        <div class="container">
            <!-- <div class="footer-social">
                <div class="social-items">
                    <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                        <svg-icon icon-class="instagram" className="icon-soc icon-instagram"/>
                    </a>
                    <a :href="setup.footer_social_links.face" class="social-item" target="_blank">
                        <svg-icon icon-class="facebook" className="icon-soc icon-facebook"/>
                    </a>
                    <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                        <svg-icon icon-class="telegram" className="icon-soc icon-telegram"/>
                    </a>
                </div>
            </div> -->
            <div class="copy">
                <p>{{salesCard.shablon_footer_copy}}</p>
                <a href="https://sales.bazis.kz/privacy-policy" target="_blank" class="link-to-policy" v-if="projectHost != 'nurly-dala2'">
                    <span v-if="globalLang == ''">Политика конфиденциальности</span>
                    <span v-else>Құпиялылық саясаты</span>
                </a>
            </div>
            <div class="made-in">
                <p>Developed by</p>
                <a href="https://v-web.kz" target="_blank">Victory WEB</a>
            </div>
        </div>
    </footer>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'AppFooter',
        data () {
            return {
                projectHost: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        components: {
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
        }),
    }
</script>

<style lang="scss">
    @import '@/styles/components/footer/footer.scss';
    // @import '@/styles/respond/footer/respond-footer.scss';
</style>